export default $axios => {   
    return {
        async area(id) {
            return await $axios.get(`/simulator/charts/${id}/area`);  
        },
    
        async daily(id) {
            return await $axios.get(`/simulator/charts/${id}/daily`);  
        },

        async hourly(id) {
            return await $axios.get(`/simulator/charts/${id}/hourly`);  
        },
    } 
}; 